'use client';

import React from 'react';
import Txt, { TxtProps } from '../ui/Txt';
import { useView } from '@/lib/store/hooks';
import { PageHeaderProps } from '.';
import { PageEntryTypes } from '@/lib/parsers/entries';
import Grid, { GridColProps } from '../ui/Grid';

export type PageSummaryProps = TxtProps<
  'span',
  {
    GridColProps?: GridColProps;
    useGridCol?: boolean;
  }
> &
  Partial<PageHeaderProps>;

export default function PageSummary({
  children,
  GridColProps,
  useGridCol = true,
  ...props
}: PageSummaryProps) {
  const page = useView() as PageEntryTypes;
  const summary = page?.summary ?? null;

  const content = children || summary;

  const Content = () =>
    content && (
      <Txt as="span" variant="large" {...props}>
        {content}
      </Txt>
    );

  return useGridCol && content ? (
    <Grid.Col md={8} {...GridColProps}>
      <Content />
    </Grid.Col>
  ) : (
    <Content />
  );
}
